import { useCallback, useRef, useState } from "react";

interface UseHoverableReturn {
	isHovered: boolean;
	handleMouseEnter: () => void;
	handleMouseLeave: () => void;
	/** Immediately clear hover (and any pending leave timeout). */
	clearHover: () => void;
}

export default function useHoverable(delay = 0): UseHoverableReturn {
	const [isHovered, setIsHovered] = useState(false);
	const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

	const clearHover = useCallback((): void => {
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
			timeoutRef.current = null;
		}
		setIsHovered(false);
	}, []);

	const handleMouseEnter = useCallback((): void => {
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
			timeoutRef.current = null;
		}
		setIsHovered(true);
	}, []);

	const handleMouseLeave = useCallback((): void => {
		timeoutRef.current = setTimeout(() => {
			setIsHovered(false);
			timeoutRef.current = null;
		}, delay);
	}, [delay]);

	return {
		isHovered,
		handleMouseEnter,
		handleMouseLeave,
		clearHover,
	};
}
